import { useEffect, Component } from "react";
import Lenis from "lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Strip from "./components/Strip";
import Benefits from "./components/Benefits";
import GiftCatalog from "./components/GiftCatalog";
import ClosingCTA from "./components/ClosingCTA";
import Footer from "./components/Footer";
import "./index.css";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-night text-cream">
          Sesuatu berjalan salah. Muat ulang halaman.
        </div>
      );
    }
    return this.props.children;
  }
}

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-night font-sans text-cream antialiased">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Strip />
        <Benefits />
        <GiftCatalog />
        <ClosingCTA />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <Landing />
    </ErrorBoundary>
  );
}
